import {clsx} from 'clsx';
import React, {type FC} from 'react';

import {Icon, type IconName} from '../../../../Icon';
import {TailwindContents} from '../../../../Tailwind';

export const SmallRefBox: FC<{
  iconName: IconName;
  text: string;
  iconOnly?: boolean;
  isDeleted?: boolean;
}> = ({iconName, text, iconOnly = false, isDeleted = false}) => (
  <TailwindContents>
    <div className="flex items-center">
      <div
        className="mr-4 flex h-[22px] w-[22px] flex-[0_0_22px] items-center justify-center rounded-[16px]"
        style={{
          backgroundColor:
            'light-dark(color-mix(in srgb, var(--moon-300) 48%, transparent), color-mix(in srgb, var(--moon-600) 48%, transparent))',
        }}>
        <Icon name={iconName} width={14} height={14} />
      </div>
      {!iconOnly && (
        <div
          className={clsx(
            'h-[22px] min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap',
            isDeleted ? 'line-through' : 'no-underline'
          )}>
          {text}
        </div>
      )}
    </div>
  </TailwindContents>
);
